import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {
  Aangifte,
  AangifteSchenkbelasting,
  AllowanceEntity,
  BokkzClient,
  BtwOverzicht,
  ClientEntity,
  CorporateTaxEntity,
  Dividendbelasting,
  DividendTaxEntity,
  GiftTaxEntity,
  IncomeTaxEntity,
  IntermediaryEntity,
  Toeslagen,
  ValueAddedTaxEntity,
  Vermogensvergelijking,
  VpbAangifte,
} from '../services/api.bokkz.services';
import {FormBuilder, FormGroup} from '@angular/forms';
import {SelectFormControlItem, SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {ToastService} from '@snelstart/ui-toast';
import {
  BokkzRapportageClient,
  FinancialStatementValue,
  Jaarrapportage,
  JaarrapportageEntity,
  Jaarrekening,
  ProfitAppropriationValue,
  WinstEnVerliesrekeningIndelingType,
} from '../services/api.bokkz.jaarstukken';
import {ActivatedRoute} from '@angular/router';
import {SharedUiButtonModule} from '@snelstart/ui-button';
import {SharedUiDialogModule} from '@snelstart/ui-dialog';
import {SharedUiAlertModule} from '@snelstart/ui-alert';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {CommonModule} from '@angular/common';
import {BokkzAlgDataService} from '../services/bokkz-alg-data-service';
import {BokkzBtwDataService} from '../services/bokkz-btw-data-service';
import {filter, Subject, takeUntil, tap} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {BokkzVpbDataService} from '../services/bokkz-vpb-data-service';
import {BokkzIbDataService} from '../services/bokkz-ib-data-service';
import {BokkzDivDataService} from "../services/bokkz-div-data-service";
import {BokkzJrDataService} from '../services/bokkz-jr-data-service';
import {BokkzSbDataService} from '../services/bokkz-sb-data-service';
import {BokkzTslDataService} from '../services/bokkz-tsl-data-service';

@Component({
  selector: 'snelstart-venture-fiscaal-domain-logic-service',
  templateUrl: './feature-service.component.html',
  styleUrl: './feature-service.component.css',
  imports: [
    CommonModule,
    SharedUiButtonModule,
    SharedUiDialogModule,
    SharedUiAlertModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
  ],
})
export class FeatureServiceComponent implements OnInit, OnDestroy {

  @Input() public dialogVisible = false;
  @Output() public dialogVisibleChange = new EventEmitter<boolean>();
  @Input() public title: any;
  private destroy$ = new Subject<void>();
  private readonly jaarrekeningRechtspersoonRechtsvormen = ['BV', 'NV', 'COOPERATIE'];
  public isSaving = false;

  public clientId: any;
  public type: any;
  public year: any;
  public intermediairyEntity = {} as IntermediaryEntity;
  public clientEntity = {} as ClientEntity;
  public newServiceFg = {} as FormGroup;
  public optionsJaarrekeningType: SelectFormControlItem<string>[] = [];
  public optionsGrondslagType: SelectFormControlItem<string>[] = [];

  public optionsFrequentie: SelectFormControlItem<string>[] = [
    {value: 'MAAND', label: 'Maandaangifte'},
    {value: 'KWARTAAL', label: 'Kwartaalaangifte'},
    {value: 'JAAR', label: 'Jaaraangifte'},
  ];

  public optionsBiljetsoort: SelectFormControlItem<string>[] = [
    {value: 'P', label: 'P - Binnenlands belastingplichtige', disabled: false},
    {value: 'F', label: 'F - Overlijdensaangifte', disabled: false},
    {value: 'C', label: 'C - Buitenlands belastingplichtige', disabled: false},
    {value: 'M', label: 'M - Migrant', disabled: true},
  ];

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: 'Ja'},
    {value: false, label: 'Nee'},
  ];

  public optionsJaNeeFiscaleEenheid: SelectFormControlItem<boolean>[] = [
    {value: true, label: 'Ja - nog niet beschikbaar', disabled: true},
    {value: false, label: 'Nee'},
  ];

  public optionsBedrijfsklasse: SelectFormControlItem<string>[] = [
    {value: 'MICRO', label: 'Micro'},
    {value: 'KLEIN', label: 'Klein'},
    {value: 'MIDDELGROOT', label: 'Middelgroot', disabled: true},
    {value: 'GROOT', label: 'Groot', disabled: true},
  ];

  public optionsRechtsvorm: SelectFormControlItem<string>[] = [
    {value: "BV", label: "Besloten vennootschap met beperkte aansprakelijkheid"},
    {value: "NV", label: "Naamloze vennootschap" },
    {value: "COOPERATIE", label: "Coöperatie"},
    {value: "EENMANSZAAK", label: "Eenmanszaak"},
    {value: "VOF", label: "Vennootschap onder firma"},
    {value: "MAATSCHAP", label: "Maatschap"},
    {value: "CV", label: "Commanditaire vennootschap"},
  ];

  constructor(
    public fb: FormBuilder,
    private bokkzClient: BokkzClient,
    private algDataService: BokkzAlgDataService,
    private vpbDataService: BokkzVpbDataService,
    private btwDataService: BokkzBtwDataService,
    private jrDataService: BokkzJrDataService,
    private ibDataService: BokkzIbDataService,
    private divDataService: BokkzDivDataService,
    private schenkDataService: BokkzSbDataService,
    private tslDataService: BokkzTslDataService,
    private activatedRoute: ActivatedRoute,
    private bokkzRapportageClient: BokkzRapportageClient,
    private readonly toastService: ToastService,
  ) {
    this.newServiceFg = this.fb.group({
      name: null as unknown as undefined,
      fiscalnumber: null as unknown as undefined,
      type: null as unknown as undefined,
      year: null as unknown as number,
      biljet: null as unknown as string,
      jrJaarrekeningType: null as unknown as undefined,
      jrGrondslagType: null as unknown as undefined,
      jrClassificatie: null as unknown as undefined,
      jrRechtsvorm: null as unknown as undefined,
      jrPlaats: null as unknown as undefined,
      frequentie: null as unknown as string,
      fiscaleEenheid: null as unknown as boolean,
    });
  }

  ngOnInit(): void {
    this.activatedRoute.params
      .pipe(
        takeUntil(this.destroy$),
        filter((params) => !!params['clientId']),
        switchMap((params) =>
          this.bokkzClient.getClient(params['clientId']).pipe(
            tap((clientEntity) => {
              this.clientId = params['clientId'];
              this.clientEntity = clientEntity;
              this.newServiceFg.patchValue({name: clientEntity.name,
                                            jrPlaats: clientEntity.place});
            }),
          ),
        ),
      )
      .subscribe(() => {
        this.algDataService.selectedYear.pipe(takeUntil(this.destroy$)).subscribe((selectedYear) => {
          this.year = selectedYear;
          this.newServiceFg.patchValue({year: selectedYear});
        });
        this.algDataService.selectedService.pipe(takeUntil(this.destroy$)).subscribe((type) => {
          this.type = type;
          let fiscalnumber = '';
          if (type.startsWith('BTW') && this.clientEntity?.taxIdVat) {
            fiscalnumber = this.clientEntity.taxIdVat;
          }
          else if (type.startsWith('JR') && this.clientEntity?.kvkId) {
            fiscalnumber = this.clientEntity.kvkId;
          }
          else if (this.clientEntity?.taxId) {
            fiscalnumber = this.clientEntity.taxId;
          }
          this.newServiceFg.patchValue({type, fiscalnumber});

          if(type.startsWith('JR')) {
            if(this.clientEntity?.classificatie) {
              this.newServiceFg.patchValue({jrClassificatie: this.clientEntity.classificatie});
            }
            this.newServiceFg.patchValue({jrJaarrekeningType: "ENKELVOUDIG"});
          }
        });
      });
    this.initializeOptionsJaarrekeningType();
    this.initializeOptionsGrondslagType();
    this.algDataService.intermediary.subscribe((intermediary)=>{
        this.intermediairyEntity=intermediary
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public initializeOptionsJaarrekeningType(): void {
    this.optionsJaarrekeningType = [
      {value: 'ENKELVOUDIG', label: 'Enkelvoudige jaarrekening'},
      {value: 'GECONSOLIDEERD', label: 'Geconsolideerde jaarrekening', disabled: true},
    ];
  }
  get jaarrekeningRechtsvormRechtspersoon(): boolean {
    return this.jaarrekeningRechtspersoonRechtsvormen.includes(
      this.newServiceFg.get('jrRechtsvorm')?.value
    );
  }

  public initializeOptionsGrondslagType(): void {
    this.optionsGrondslagType = [
      {value: 'COMMERCIEEL', label: 'Commercieel'},
      {value: 'FISCAAL', label: 'Fiscaal'},
    ];
  }

  public saveDisabled(): boolean {
    if (this.type === "JR") {
      const jrJaarrekeningType = this.newServiceFg.value.jrJaarrekeningType;
      const jrGrondslagType = this.newServiceFg.value.jrGrondslagType;
      const jrClassificatie = this.newServiceFg.getRawValue().jrClassificatie;
      const jrRechtsvorm = this.newServiceFg.getRawValue().jrRechtsvorm;
      const fiscalnumber = this.newServiceFg.getRawValue().fiscalnumber;
      if (!jrJaarrekeningType || !jrGrondslagType || !jrClassificatie || !jrRechtsvorm || !fiscalnumber) {
        return true;
      }
    }
    if (this.type === "IB") {
      const biljet = this.newServiceFg.value.biljet;
      if (!biljet) {
        return true;
      }
    }
    return false
  }

  public saveForm() {
    if (this.isSaving) return;

    this.isSaving = true;
    const type = this.newServiceFg.getRawValue().type;
    const year = this.newServiceFg.getRawValue().year;
    const fiscalnumber = this.newServiceFg.getRawValue().fiscalnumber;
    const jrJaarrekeningType = this.newServiceFg.value.jrJaarrekeningType;
    const jrGrondslagType = this.newServiceFg.value.jrGrondslagType;
    const jrClassificatie = this.newServiceFg.getRawValue().jrClassificatie;
    const jrRechtsvorm = this.newServiceFg.value.jrRechtsvorm;
    const jrPlaats = this.clientEntity.place;
    const fe = this.newServiceFg.value.fiscaleEenheid;
    if (type === 'VPB') {
      const newAangifte = {
        biljetSoort: 'A',
        boekjaar: {
          begindatum: new Date(year + '-01-01'),
          einddatum: new Date(year + '-12-31'),
        },
        identificatie: {
          naamLichaam: this.clientEntity.name,
          fiscaalNummer: fiscalnumber,
          beconnummer: this.intermediairyEntity.beconId,
          achternaamOndertekenaar: this.intermediairyEntity.officeName,
          aangifteFiscaleEenheid: false,
        },
        algemeneVragen: {
          verzoekExplicietStandpunt: false,
          regelingFunctioneleValuta: false,
          gebruikInnovatiebox: false,
          internationaleHoustervennootschap: false,
          toepassingBesluitBeleggingsinstellingen: false,
          toepassingBesluitWinstbepalingVerzekeraars: false,
          activiteitenOndernemingGewijzigd: false,
          wijzigingWaarderingsstelsel: false,
          willekeurigAfschijven: false,
          nieuweOfGewijzigdePensioenregeling: false,
          pensioenaanspraakVerminderd: false,
          vervreemdingAfgewaardeerdeVordering: false,
          aftrekValutaverliesOpDeelnemingen: false,
          verdelingAandelenkapitaalGewijzigd: false,
          beperkingVerliesverrekeningInOverdrachtsjaar: false,
          earnOutRegeling: false,
          toepassingTegenbewijsRenteaftrek: false,
          schulden10aBuitenFiscaleEenheid: false,
          compenserendeHeffing10aSchulden: false,
          kennisCompenserende10aHeffingOntvanger: false,
          saldoVorderingenEnSchuldenVerbondenLichamen: 0,
          kwalificatieBelastbareWinst: false,
          betaaldBedragVoorActiva: 0,
          rechtshandelingenMetBuitenlandseAandeelhouders: false,
          lokaalDossierBedrijfsreorganisatieOfAfdrachten: false,
          belangInFiscaalTransparanteEntiteit: false,
          vermogenAfgezonderdInApv: false,
        },
        balansEnResultatenrekening: {
          naamVennootschap: this.clientEntity.name,
          fiscaalNummer: fiscalnumber,
          boekjaarVennootschap: {
            begindatum: new Date(year + '-01-01'),
            einddatum: new Date(year + '-12-31'),
          },
          dochtermaatschappijFiscaleEenheid: false,
          agrarischeActiviteiten: false,
        },
        vermogensvergelijking: {} as Vermogensvergelijking,
      } as VpbAangifte;
      const entity = {
        name: this.clientEntity.name,
        taxPayerFiscalNumber: fiscalnumber,
        sstRelationId: this.clientEntity.sstRelationId,
        year: year,
        aangifte: newAangifte,
      } as CorporateTaxEntity;
      this.bokkzClient.postCorporateTax(this.clientEntity.sstRelationId!, false, false, entity).subscribe({
        next: (response) => {
          if (response.aangifte) {
            this.vpbDataService.updateAangifte(response.aangifte);
            this.vpbDataService.updateCorporateTaxEntity(response);
          }
        },
        error: (err) => {
          this.dialogVisibleChange.emit(false);
          console.log(err);
          this.toastService.showErrorMessage('Geen nieuwe aangifte toegevoegd.');
        },
        complete: () => this.dialogVisibleChange.emit(false),
      });
    }
    if (type === 'DB') {
      const newAangifte = {
        dienstverlener: {
          naamDienstverlener: this.intermediairyEntity.officeName,
          rsinDienstverlener: this.intermediairyEntity.taxId,
          beconNummer: this.intermediairyEntity.beconId,
        },
        inhoudingsplichtige: {
          rsinInhoudingsplichtige: this.clientEntity.taxId,
          naamInhoudingsplichtige: this.clientEntity.name,
        },
      } as Dividendbelasting;
      const entity = {
        name: this.clientEntity.name,
        taxPayerFiscalNumber: this.clientEntity.taxId,
        sstRelationId: this.clientEntity.sstRelationId,
        year: year,
        aangifte: newAangifte,
      } as DividendTaxEntity;
      this.bokkzClient.postDividendTax(this.clientEntity.sstRelationId!, false, entity).subscribe({
        next: (response) => {
          if (response && response.aangifte != null) {
            this.divDataService.updateDividendTaxEntity(response);
          }
        },
        error: (err) => {
          this.dialogVisibleChange.emit(false);
          console.log(err);
          this.toastService.showErrorMessage('Geen nieuwe aangifte toegevoegd.');
        },
        complete: () => this.dialogVisibleChange.emit(false),
      });
    }
    if (type === 'IB') {
      const newAangifte = {
        biljetSoort: this.newServiceFg.value.biljet,
        aangifteJaar: year,
        aangever: {
          voorletters: this.clientEntity.voorletters,
          tussenvoegsels: this.clientEntity.tussenvoegsel !== undefined ? this.clientEntity.tussenvoegsel : null,
          achternaam: this.clientEntity.achternaam,
          bsn: this.clientEntity.taxId,
          geboortedatum: this.clientEntity.geboortedatum,
        },
        vertegenwoordiger: {
          beconnummer: this.intermediairyEntity.beconId,
          naamDienstVerlener: this.intermediairyEntity.officeName,
        },
      } as Aangifte;
      const entity = {
        name: this.clientEntity.name,
        taxPayerFiscalNumber: this.clientEntity.taxId,
        sstRelationId: this.clientEntity.sstRelationId,
        year: year,
        aangifte: newAangifte,
      } as IncomeTaxEntity;
      this.bokkzClient.postIncomeTax(this.clientEntity.sstRelationId!, false, false, false, false, entity).subscribe({
        next: (response) => {
          if (response && response.aangifte != null) {
            this.ibDataService.updateIncomeTaxEntity(response);
          }
        },
        error: (err) => {
          this.dialogVisibleChange.emit(false);
          console.log(err);
          this.toastService.showErrorMessage('Geen nieuwe aangifte toegevoegd.');
        },
        complete: () => this.dialogVisibleChange.emit(false),
      });
    }
    if (type == 'TSL') {
      const newToeslagen = {
        berekeningsjaar: year,
        bsn: this.clientEntity.taxId,
      } as Toeslagen;
      const newAllowanceEntity = {
        name: this.clientEntity.name,
        taxPayerFiscalNumber: this.clientEntity.taxId,
        sstRelationId: this.clientEntity.sstRelationId,
        year: year,
        toeslagen: newToeslagen,
      } as AllowanceEntity;
      this.bokkzClient.postAllowance(this.clientEntity.sstRelationId!, false, newAllowanceEntity).subscribe({
        next: (response) => {
          if (response && response.year != null) {
            this.tslDataService.updateAllowanceTaxEntity(response)
          }
        },
        error: (err) => {
          this.dialogVisibleChange.emit(false);
          console.log(err);
          this.toastService.showErrorMessage('Geen nieuwe aangifte toegevoegd.');
        },
        complete: () => this.dialogVisibleChange.emit(false),
      });
    }
    if (type === 'BTW') {
      const newAangifte = {
        jaar: year,
        achternaamBelastingplichtige: this.clientEntity.name,
        omzetbelastingNummer: this.clientEntity.taxIdVat,
        beconNummer: this.intermediairyEntity.beconId,
        naamContactPersoon: this.intermediairyEntity.officeName,
        frequentie: this.newServiceFg.value.frequentie,
        fiscaleEenheid: false,
      } as BtwOverzicht;
      const newEntity = {
        name: this.clientEntity.name,
        sstRelationId: this.clientEntity.sstRelationId,
        taxPayerFiscalNumber: fiscalnumber,
        year: year,
        overzicht: newAangifte,
      } as ValueAddedTaxEntity;
      this.bokkzClient.postValueAddedTax(this.clientEntity.sstRelationId!, false, newEntity).subscribe({
        next: (response) => {
          if (response && response.year != null) {
            this.btwDataService.updateValueAddedTaxEntity(response);
          }
        },
        error: (err) => {
          this.dialogVisibleChange.emit(false);
          console.log(err);
          this.toastService.showErrorMessage('Geen nieuwe aangifte toegevoegd.');
        },
        complete: () => this.dialogVisibleChange.emit(false),
      });
    }
    if (type === 'SB') {
      const newAangifte = {
        schenker: {
          voorletters: this.clientEntity.voorletters,
          tussenvoegsels: this.clientEntity.tussenvoegsel,
          achternaam: this.clientEntity.achternaam,
          bsn: this.clientEntity.taxId,
        },
        aangever: {
          voorletters: this.clientEntity.voorletters,
          tussenvoegsels: this.clientEntity.tussenvoegsel,
          achternaam: this.clientEntity.achternaam,
          bsn: this.clientEntity.taxId,
        },
      } as AangifteSchenkbelasting;
      const newEntity = {
        year: year,
        taxPayerFiscalNumber: this.clientEntity.taxId,
        sstRelationId: this.clientEntity.sstRelationId,
        aangifte: newAangifte,
        lastOpeningDate: new Date(),
      } as GiftTaxEntity;
      this.bokkzClient.postGiftTax(this.clientEntity.sstRelationId!, false, newEntity).subscribe({
        next: (response) => {
          if (response && response.year != null) {
            this.schenkDataService.updateGiftTaxEntity(response)
          }
        },
        error: (err) => {
          this.dialogVisibleChange.emit(false);
          console.log(err);
          this.toastService.showErrorMessage('Geen nieuwe aangifte toegevoegd.');
        },
        complete: () => this.dialogVisibleChange.emit(false),
      });
    }
    if (type === 'JR') {
      const jaarrekening = {
        jaarrekeningType: jrJaarrekeningType,
        balans: {
          balanceSheetBeforeAfterAppropriationResults: {
            value: ProfitAppropriationValue.VOOR,
          },
        },
        winstEnVerliesrekening: {
          winstEnVerliesrekeningIndelingType: WinstEnVerliesrekeningIndelingType.BEDRIJFSOPBRENGSTEN_BEDRIJFSLASTEN,
        },
      } as Jaarrekening;
      const newJaarrapport = {
        informatieEntiteit: {
          legalEntityName: {value: this.clientEntity.name},
          businessNames: {value: this.clientEntity.name},
          chamberOfCommerceRegistrationNumber: {value: this.clientEntity.kvkId},
          legalSizeCriteriaClassification: {value: jrClassificatie},
          legalEntityLegalForm: {value: jrRechtsvorm},
          legalEntityRegisteredOffice: { value: jrPlaats },
          sbiBusinessCode: {value: this.clientEntity.sbiCode},
          adres: {
            streetNameNL: {value: this.clientEntity.street},
            houseNumberNL: {value: this.clientEntity.houseNumber},
            houseNumberAddition: {value: this.clientEntity.numberAddition},
            postalCodeNL: {value: this.clientEntity.postalCode},
            placeOfResidenceNL: {value: this.clientEntity.place},
          }
        },
        informatieRapportage: {
          titleOfTheDocument: {value: 'Jaarrapportage ' + year},
          financialReportingPeriodCurrentStartDate: {
            value: new Date(year + '-01-01'),
          },
          financialReportingPeriodCurrentEndDate: {
            value: new Date(year + '-12-31'),
          },
          documentRelatesToIndividualEntityOrGroup: {
            value: FinancialStatementValue.ENKELVOUDIG,
          },
          documentPresentationCurrency: {value: 'EUR'},
          basisOfPreparation: {value: jrGrondslagType},
        },
        jaarrekeningen: [jaarrekening],
      } as Jaarrapportage;
      const newEntity = {
        year: year,
        rapportage: newJaarrapport,
        dateCreation: new Date(),
      } as JaarrapportageEntity;
      if (this.clientEntity.sstRelationId) {
          this.bokkzRapportageClient.postjaarrapportage(this.clientEntity.sstRelationId, String(newEntity.year), false, undefined, newEntity).subscribe({
              next: (response) => {
                  if (response && response.year != null) {
                      this.jrDataService.updateEntity(response)
                  }
              },
              error: (err) => {
                  this.dialogVisibleChange.emit(false);
                  console.log(err);
                  this.toastService.showErrorMessage('Geen nieuwe rapportage toegevoegd.');
              },
              complete: () => this.dialogVisibleChange.emit(false),
          });
      }
    }
    setTimeout(() => {
      this.isSaving = false;
      this.dialogVisibleChange.emit(false);
    }, 1000);
  }
}
